

import { IChuongTrinhDaoTaoChiTietUpdateCongThucRequest } from "../../../model/request/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietUpdateCongThucRequest";
import { IChuongTrinhDaoTaoChiTietRespone } from "../../../model/response/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IChuongTrinhDaoTaoChiTietActionTypeBase<T> {
    id_dt: number,
    data: T
}
export const eChuongTrinhDaoTaoChiTietActionsObj = {
    INI_START: 0,
    LOAD_BY_CTDT_START: 0,
    LOAD_BY_CTDT_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietRespone>,
    LOAD_BY_CTDT_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,
    CHANGE_FOCUSED_TAB: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<"mon-hoc" | "tu-chon" | "rang-buoc" | "lop">,

    UPDATE_CONG_THUC_START: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietUpdateCongThucRequest>,
    UPDATE_CONG_THUC_SUCCESS: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,
    UPDATE_CONG_THUC_ERROR: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<string>,

    UPLOAD_CONG_THUC_MODAL_OPEN: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<undefined>,
    UPLOAD_CONG_THUC_MODAL_CLOSE: {} as IChuongTrinhDaoTaoChiTietActionTypeBase<undefined>,

};
export const eChuongTrinhDaoTaoChiTietActionIds = generateActionTypeIds(
    eChuongTrinhDaoTaoChiTietActionsObj,
    "CHUONG_TRINH_DAO_TAO_CHI_TIET"
);
export type IChuongTrinhDaoTaoChiTietActionTypes = IGenericActionType<
    typeof eChuongTrinhDaoTaoChiTietActionsObj,
    "CHUONG_TRINH_DAO_TAO_CHI_TIET"
>;
